import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidatorFn, AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { sortByFirstLetter } from 'src/app/utils/autoSelect';
import { CodebookService } from 'src/services/codebook.service';
import { CpsuSubjectService } from 'src/services/cpsu-subject.service';
import { ToastrImplService } from 'src/services/toastr.service';
enum AutocompleteFilterEnum {
   FOSTER_PARENT = 'FOSTER_PARENT',
}
@Component({
   selector: 'app-connect-disconnect-cpsu-foster-child',
   templateUrl: './connect-disconnect-cpsu-foster-child.component.html',
   styleUrls: ['./connect-disconnect-cpsu-foster-child.component.scss'],
})
export class ConnectDisconnectCpsuFosterChildComponent implements OnInit {
   centers: any;
   fosterChildCpsuForm: FormGroup;
   fosterParentList: any[] = [];
   filteredFosterParent: Observable<any[]>;
   users: any;
   message: string = '';
   constructor(
      private formBuilder: FormBuilder,
      public dialogRef: MatDialogRef<any>,
      @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
      public dialog: MatDialog,
      private codebookService: CodebookService,
      private cpsuSubjectService: CpsuSubjectService,
      private toastr: ToastrImplService,
   ) {
      this.codebookService.getAllCpsuCenter().subscribe(result => {
         this.centers = result.filter((c: any) => c.id !== 1).sort((a: any, b: any) => a.name.localeCompare(b.name));
         this.cpsuSubjectService.findWhereSubjectExist(this.data.fosterChildSubjectId).subscribe((res: any[]) => {
            this.centers = this.centers.filter((center: any) => res.some(r => r === center.id));
         });
      });
   }

   ngOnInit(): void {
      this.fosterChildCpsuForm = this.formBuilder.group({
         center: [null],
         fosterChildData: [this.data.fosterChildData || ''],
         fosterParentData: new FormControl({ value: '', disabled: true }, [Validators.required, this.validateFosterParent]),
      });
      this.fosterChildCpsuForm.controls.center.valueChanges.subscribe((val: any) => {
         if (val == null || val === '') {
            return;
         }
         this.fosterChildCpsuForm.controls.fosterParentData.enable();
         this.cpsuSubjectService.findFosterParentsForCsrAndCpsu(val).subscribe((res: any[]) => {
            this.fosterParentList = res;
            this.filteredFosterParent = this.fosterChildCpsuForm.controls.fosterParentData.valueChanges.pipe(
               startWith(''),
               map(value => (typeof value === 'string' ? value : value?.name)),
               map(title => (title ? this._filter(title, AutocompleteFilterEnum.FOSTER_PARENT) : this.fosterParentList.slice())),
            );
         });
      });
   }

   sendRequest() {
      const body = {
         cpsuId: this.fosterChildCpsuForm.value.center,
         fosterParentCpsuSubjectId: this.fosterChildCpsuForm.value.fosterParentData.id,
         fosterChildSubjectId: this.data.fosterChildSubjectId,
      };
      this.cpsuSubjectService.connectFosterChildToFosterParent(body).subscribe(
         result => {
            this.toastr.success('CASES.CPSU.SUCCESS_CONNECT_FOSTER_CHILD');
            this.dialogRef.close({ event: 'success', data: body });
         },
         error => {
            if (error.status === 500 && error.error && error.error === 'ALREADY_CONNECTED') {
               this.toastr.error('CASES.CPSU.FOSTER_CHILD_ALREADY_CONNECTED');
            } else {
               this.toastr.error('SNACKBAR.ERROR_OCCURRED');
            }
         },
      );
   }
   disconectFosterSubject() {
      this.cpsuSubjectService.disconnectFosterChildFromFosterParent(this.data.fosterChildSubjectId).subscribe(
         result => {
            this.toastr.success('CASES.CPSU.SUCCESS_DISCONNECT_FOSTER_CHILD');
            this.dialogRef.close({ event: 'success' });
         },
         error => {
            this.toastr.error('SNACKBAR.ERROR_OCCURRED');
         },
      );
   }
   closeDialog() {
      this.dialogRef.close({ event: 'cancel' });
   }

   autoSelectFosterParent() {
      const temp = this.fosterChildCpsuForm.value.fosterParentData;
      if (temp != null && typeof temp !== 'string') {
         return;
      }
      const searchValue = (temp ?? '').toLowerCase();

      const founded = this.fosterParentList.filter(
         fosterParent =>
            (fosterParent.firstName ?? '').toLowerCase().includes(searchValue) || (fosterParent.lastName ?? '').toLowerCase().includes(searchValue) || (fosterParent.jmbg ?? '').includes(searchValue),
      );
      if (founded.length === 0) {
         this.fosterChildCpsuForm.controls.fosterParentData.setErrors({ notValid: true });
         return;
      } else {
         this.fosterChildCpsuForm.controls.fosterParentData.setValue(founded[0]);
         this.fosterChildCpsuForm.controls.fosterParentData.setErrors(null);
      }
   }

   displayCustomFormat(fosterParent: any): string {
      return fosterParent ? fosterParent.firstName + ' ' + fosterParent.lastName + ', ' + fosterParent.jmbg : '';
   }

   private _filter(value: string, what: AutocompleteFilterEnum): any[] {
      const filterValue = value.toLowerCase();

      switch (what) {
         case AutocompleteFilterEnum.FOSTER_PARENT: {
            return sortByFirstLetter(
               this.fosterParentList.filter(
                  (option: any) =>
                     (option.firstName ?? '').toLowerCase().includes(filterValue) || (option.lastName ?? '').toLowerCase().includes(filterValue) || (option.jmbg ?? '').includes(filterValue),
               ),
               filterValue,
               'name',
            );
         }
         default:
            break;
      }
   }
   validateFosterParent(control: AbstractControl): ValidationErrors | null {
      const value = control.value;

      return value && typeof value === 'object' && value.id ? null : { invalidFosterParent: true };
   }
   fosterParentValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
         const value = control.value;

         if (!value || typeof value !== 'object' || !value.id) {
            return { invalidFosterParent: true };
         }

         return null;
      };
   }
}
